import {Injectable} from '@angular/core';
import {bindCallback, bindNodeCallback, ConnectableObservable, Observable, of, ReplaySubject, throwError} from 'rxjs';
import {map, multicast, switchMap} from 'rxjs/operators';
import {ExgMapAPILoader} from './exg-map-api-loader.service';

@Injectable({providedIn: 'root'})
export class ExgMapDistanceMatrixService {
  protected readonly distanceMatrix$: Observable<google.maps.DistanceMatrixService>;

  constructor(loader: ExgMapAPILoader) {
    const connectableDistanceMatrix$ = new Observable(subscriber => {
      loader.load().then(() => subscriber.next());
    })
      .pipe(
        map(() => this._createDistanceMatrix()),
        multicast(new ReplaySubject(1)),
      ) as ConnectableObservable<google.maps.DistanceMatrixService>;

    connectableDistanceMatrix$.connect();
    this.distanceMatrix$ = connectableDistanceMatrix$;
  }

  private _createDistanceMatrix(): google.maps.DistanceMatrixService {
    return new google.maps.DistanceMatrixService();
  }

  private _getGoogleResults(distanceMatrixService: google.maps.DistanceMatrixService, request: google.maps.DistanceMatrixRequest):
    Observable<google.maps.DistanceMatrixResponse> {
    const distanceMatrixObservable = bindCallback(distanceMatrixService.getDistanceMatrix);
    return distanceMatrixObservable(request).pipe(
      switchMap(([response, status]) => {
        if (status === google.maps.DistanceMatrixStatus.OK) {
          return of(response) as  Observable<google.maps.DistanceMatrixResponse>;
        }
        return throwError(status);
      })
    );

  }

  public getDistanceMatrix(request: google.maps.DistanceMatrixRequest): Observable<google.maps.DistanceMatrixResponse> {
    return this.distanceMatrix$.pipe(
      switchMap((distanceMatrix) => this._getGoogleResults(distanceMatrix, request))
    );
  }


}
